import { useEffect, useState } from "react";
import { useGetAllPOIsQuery } from "../Redux/service/POIS/POIs";

const PAGE_SIZE = 10;

export function useInfinitePoiOptions(searchTerm = "") {
	const [page, setPage] = useState(1);
	const [accumulated, setAccumulated] = useState([]);

	useEffect(() => {
		setPage(1);
		setAccumulated([]);
	}, [searchTerm]);

	const { data, isFetching } = useGetAllPOIsQuery(
		{ page, limit: PAGE_SIZE, search: searchTerm, status: "true" },
		{ refetchOnMountOrArgChange: true }
	);

	useEffect(() => {
		if (!data?.data) return;
		setAccumulated((prev) => (page === 1 ? data.data : [...prev, ...data.data]));
	}, [data, page]);

	const hasMore = (data?.data?.length ?? 0) === PAGE_SIZE;

	const options = accumulated.map((poi) => ({
		label: poi.name,
		value: poi.id,
	}));

	return {
		options,
		isFetching,
		hasMore,
		loadMore: () => {
			if (hasMore && !isFetching) setPage((prev) => prev + 1);
		},
	};
}
